import { ScheduleMenu } from "@bryntum/schedulerpro";
import { PLUGINS_KEYS } from "../../other/constants/PluginKeys.jsx";
import { SwivuSchedulerMenuPluginMixin } from "./mixins/SwivuSchedulerMenuPluginMixin";

export default class SwivuSchedulerMenuPlugin extends SwivuSchedulerMenuPluginMixin(ScheduleMenu) {

  static get $name() {
    return PLUGINS_KEYS.schedulerMenu;
  }

  static get pluginConfig() {
    return {
      chain: ["populateScheduleMenu"]
    };
  }

  populateScheduleMenu(event) {
    const { items, record } = event;
    if (record) {
      // add event, but it doesn't work like we expect, so we just disable this menu for a while
      if (items.addEvent) items.addEvent = false;
      const { insertTask } = SwivuSchedulerMenuPlugin.itemsKeyRef;
      Object.assign(items, {
        [insertTask]: this.getScheduleTaskMenuItem(),
      });
      items[insertTask].disabled = record.isGroupHeader;
    }
  }
}
